<template>
  <b-dropdown-item-button data-test="close-dropdown-button" @click.stop="$emit('close-dropdown')">
    <sdui-icon data-test="close-dropdown-button-icon"
               class="icon-close-o-16 close-dropdown-icon"
               variant="secondary"
    />
    <span data-test="close-dropdown-button-label" class="ml-2 d-inline-block align-middle">{{ $t('global.close') }}</span>
  </b-dropdown-item-button>
</template>

<script>
export default {
  name: 'SDropDownCloseButton',

  emits: ['close-dropdown'],
}
</script>

<style scoped lang="scss">
.close-dropdown-icon {
  background-color: $color-secondary;
  color: $color-gray-300 !important;
  height: 28px;
  width: 28px;

  &::before {
    font-weight: $font-weight-bold !important;
    font-size: pxtorem(16);
  }
}
</style>
